import React, { HTMLAttributes } from "react";
import classNames from "classnames";

import { StyledCard } from "./Card.styled";

type Props = {
  /**
   * Set card is active
   *
   */
  active?: boolean;

  /**
   * Set card has hover state
   */
  hoverable?: boolean;

  disabled?: boolean;
} & HTMLAttributes<HTMLDivElement>;

const defaultProps = {
  active: false,
  hoverable: false
};

const Card = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { children, className, active, hoverable, disabled, ...restProps } = props;
  const cardClass = classNames(
    "c-card",
    active && "is-active",
    hoverable && "is-hoverable",
    disabled && "is-disabled",
    className
  );

  return (
    <StyledCard data-testid="qa-card" ref={ref} className={cardClass} {...restProps}>
      {children}
    </StyledCard>
  );
});

Card.defaultProps = defaultProps;

export default Card;
